import type { Discussion } from 'hb-builder/components/BuilderComponents/dynamic/types/discussions';
import type { Event } from 'hb-builder/components/BuilderComponents/dynamic/types/event';
import type { News } from 'hb-builder/components/BuilderComponents/dynamic/types/news';
import type { AuthenticationIds } from 'hb-builder/types/config/AuthenticationIds';
import { getEventDedicatedPath } from 'hb-react/shared/apps/Events/utils/getEventDedicatedUrl';

interface ModuleDetailPageProps {
  discussion?: Discussion;
  ids: AuthenticationIds;
  navigate: (url: string) => void;
  isBackOffice: boolean;
  event?: Event;
  news?: News;
  topicHref?: string;
  whiteLabelUrl?: string | null;
}

export const getEventLinkUrl = ({
  event,
  ids,
  whiteLabelUrl,
}: {
  ids: AuthenticationIds;
  event: Pick<Event, 'id' | 'type'>;
  whiteLabelUrl?: string | null;
}): string =>
  getEventDedicatedPath({
    hasUser: Boolean(ids.user),
    event,
    topicId: ids.topic,
    isWhitelabelGroup: !!whiteLabelUrl,
  });

export const getNewsLinkUrl = ({
  ids,
  news,
  whiteLabelUrl,
}: {
  ids: AuthenticationIds;
  news: News;
  whiteLabelUrl?: string | null;
}): string => {
  const newsPublishedPagePath =
    ids.topic && !whiteLabelUrl
      ? Routes.topic_new_path(ids.topic, news.id)
      : Routes.new_json_path(news.id);

  return newsPublishedPagePath;
};

export const getDiscussionLinkUrl = ({ discussion, ids }): string => {
  const discussionPagePath = ids.topic
    ? Routes.show_topic_forum_thread_path(ids.topic, discussion.id)
    : Routes.forum_thread_path(discussion.id);

  return discussionPagePath;
};

export const goToModuleDetailPage = ({
  discussion,
  event,
  ids,
  isBackOffice,
  navigate,
  news,
  topicHref,
  whiteLabelUrl,
}: ModuleDetailPageProps): void => {
  if (!(discussion || event || news || topicHref) || isBackOffice) {
    return;
  }

  if (discussion) {
    const discussionLink = getDiscussionLinkUrl({ discussion, ids });

    navigate(discussionLink);
  }

  if (event) {
    const eventLink = getEventLinkUrl({ event, ids, whiteLabelUrl });

    navigate(eventLink);
  }

  if (news) {
    const newsLink = getNewsLinkUrl({ ids, news, whiteLabelUrl });

    navigate(newsLink);
  }

  if (topicHref) {
    navigate(topicHref);
  }
};
